<ng-container [formGroup]="form">
  <div id="creditcard_cardnumber" class="input creditcard-indicator">
    <label class="required" i18n="@@payment_method.label.creditcard_number"> Kreditkarten-Nummer </label>
    <input
      type="text"
      [ngClass]="creditCardType$ | async"
      class="form-control"
      formControlName="number"
      placeholder="4444 3333 2222 1111"
      ccNumber
      (input)="onInputFormatCreditCard($event)"
      maxlength="23"
    />
    <orderform-input-errors [control]="form.get('number')"></orderform-input-errors>
  </div>

  <div class="d-flex">
    <div id="creditcard_expires" class="input">
      <label class="required" i18n="@@payment_method.label.valid_to"> Gültig bis </label>
      <input
        class="form-control"
        type="text"
        [placeholder]="expiresPlaceholder"
        formControlName="expires"
        (input)="onInputFormatExpires($event)"
      />
      <orderform-input-errors [control]="form.get('expires')"></orderform-input-errors>
    </div>
    <div id="creditcard_securitycode" class="input">
      <div class="label-container">
        <label i18n="@@payment_method.label.cvv" class="required">CVV </label>
        <a
          id="creditcard_securitycode_help"
          href="#"
          tabindex="-1"
          i18n="Es geht um die Kreditkartenprüfnummer@@lpayment_method.label.cvv_whats_this"
          (click)="$event.preventDefault(); cvcDialog.open()"
          >Was ist das?</a
        >
      </div>
      <input
        type="text"
        placeholder="●●●"
        class="form-control"
        formControlName="cvv"
        (input)="onInputFormatCvv($event)"
        [maxlength]="(creditCardType$ | async) === 'americanexpress' ? 4 : 3"
      />
      <orderform-input-errors [control]="form.get('cvv')"></orderform-input-errors>
    </div>
  </div>

  <orderform-cvc-dialog #cvcDialog></orderform-cvc-dialog>
</ng-container>
